import PromptTable from '/src/features/ia/components/PromptTable/PromptTable';

function PromptList() {
    return <PromptTable />;
}

export default PromptList;
